/**
 * 注册或获取全局过滤器
 */
import Vue from 'vue';
import * as dict  from './dict';
import './extends/dateFormat';
//时间戳 转换成日期
//时间格式化 转换成日期
// {{1487815818000|dateFormat}}
// {{1487815818000|dateFormat('yyyy-MM-dd HH:mm')}}
// {{1487815818000|timeFormat}}
// {{1487815818000|dateTimeFormat}}

Vue.filter('parseInt', function (value) {
    return parseInt(value)
})
Vue.filter('dateFormat', function (value, fmt="yyyy-MM-dd") {
    return value ? new Date(value).format(fmt) : ""
})
Vue.filter('timeFormat', function (value) {
    return value ? new Date(value).format("HH:mm:ss") : ""
})
Vue.filter('dateTimeFormat', function (value) {
    return value ? new Date(value).format("yyyy-MM-dd HH:mm:ss") : ""
})

//显示默认图片
Vue.filter('defaultImg', function (url, setUrl='@/assets/img/nofound.png') {
    return url || setUrl
});

//显示默认信息
Vue.filter('defaultText', function (text, setText='-') {
    return text || setText
});

for (let item in dict) {
    Vue.filter(item, function(val,list) {
      let arr= dict[item]
      if(Array.isArray(list)){
        arr=list
      }
      let find = arr.find(x => x.value == val);
      return find ? find.label : val
    })
}

Vue.filter('nonePass', function (value) {
    return "***"
})

Vue.filter('format', function (timeStamp, fmt = 'yyyy-MM-dd') {
    {
        /** * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
         可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
         * eg:
         * (timeStamp).format("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
         * (timeStamp).format("yyyy-MM-dd E HH:mm:ss") == > 2009 - 03 - 10 二 20: 09: 04
         * (timeStamp).format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
         * (timeStamp).format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
         * (timeStamp).format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
         */
        if (!timeStamp) {
            return ''
        }
        if (typeof timeStamp === 'string') {
            timeStamp = Number(timeStamp)
            if (isNaN(timeStamp)) {
                return ''
            }
        }
        const time = new Date(timeStamp)
        const o = {
            'M+': time.getMonth() + 1, // 月份
            'd+': time.getDate(), // 日
            'h+': time.getHours() % 12 === 0 ? 12 : time.getHours() % 12, // 小时
            'H+': time.getHours(), // 小时
            'm+': time.getMinutes(), // 分
            's+': time.getSeconds(), // 秒
            'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
            'S': time.getMilliseconds() // 毫秒
        }
        const week = {
            '0': '/u65e5',
            '1': '/u4e00',
            '2': '/u4e8c',
            '3': '/u4e09',
            '4': '/u56db',
            '5': '/u4e94',
            '6': '/u516d'
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        if (/(E+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[time.getDay() + ''])
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt
    }
})
